// extracted by mini-css-extract-plugin
export var arrows = "_6s-6";
export var decrementer = "_6s-a";
export var disabled = "_6s-4";
export var error = "_6s-1";
export var hiddenText = "_6s-b";
export var incrementer = "_6s-9";
export var input = "_6s-8";
export var inputWrapper = "_6s-0";
export var leadingIcon = "_6s-c";
export var readonly = "_6s-3";
export var regular = "_6s-7";
export var small = "_6s-5";
export var warning = "_6s-2";